import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import Notification from "../Notification";
import Adminnavbar from "./Adminnavbar";
import Footer from "../footer";
import Scrolltotopbtn from "../Scrolltotopbutton";

// Material, condition and style used to be hardcoded <option> lists repeated
// across four components, so adding a fabric meant editing code and deploying.
// This manages them in one place; the seller form reads the same list.
const TYPES = [
  { key: "material", label: "Material", hint: "Fabrics and materials, e.g. Silk, Khadi" },
  { key: "condition", label: "Condition", hint: "How worn an item is, e.g. Like New" },
  { key: "style", label: "Style", hint: "Era or styling, e.g. Modern, 90s" },
];

const ManageAttributes = () => {
  const [options, setOptions] = useState({ material: [], condition: [], style: [] });
  const [drafts, setDrafts] = useState({ material: "", condition: "", style: "" });
  const [busy, setBusy] = useState("");
  const [notification, setNotification] = useState(null);

  const notify = (message, type) => {
    setNotification({ message, type });
    setTimeout(() => setNotification(null), 4000);
  };

  const load = useCallback(() => {
    axios
      .get(`${process.env.REACT_APP_HOST}${process.env.REACT_APP_PORT}/productattributes`)
      .then((res) => {
        if (res.data && typeof res.data === "object") setOptions(res.data);
      })
      .catch((err) => {
        console.error("Could not load options:", err.message);
        notify("Could not load the current options.", "error");
      });
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const add = (type) => {
    const value = (drafts[type] || "").trim();
    if (!value) return;
    setBusy(type);
    axios
      .post(`${process.env.REACT_APP_HOST}${process.env.REACT_APP_PORT}/productattributes`, {
        attribute_type: type,
        value,
      })
      .then(() => {
        setDrafts((d) => ({ ...d, [type]: "" }));
        notify(`Added "${value}" to ${type}.`, "success");
        load();
      })
      .catch((err) => {
        notify(err.response?.data?.error || "Could not add that option.", "error");
      })
      .finally(() => setBusy(""));
  };

  const remove = (type, option) => {
    setBusy(type);
    axios
      .delete(
        `${process.env.REACT_APP_HOST}${process.env.REACT_APP_PORT}/productattributes/${option.id}`
      )
      .then(() => {
        notify(`Removed "${option.value}".`, "success");
        load();
      })
      .catch((err) => {
        // The server refuses to remove a value that listings still use.
        notify(err.response?.data?.error || "Could not remove that option.", "error");
      })
      .finally(() => setBusy(""));
  };

  return (
    <div>
      <Adminnavbar />
      <div className="container py-4 fullscreen2">
      {notification && (
        <Notification
          message={notification.message}
          type={notification.type}
          onClose={() => setNotification(null)}
        />
      )}

      <h4 className="mb-1">Product options</h4>
      <p className="text-secondary mb-4" style={{ fontSize: "14px" }}>
        These are the choices sellers see when listing an item. Changes apply
        immediately &mdash; no deploy needed.
      </p>

      <div className="row g-3">
        {TYPES.map(({ key, label, hint }) => (
          <div className="col-12 col-lg-4" key={key}>
            <div className="border rounded p-3 h-100">
              <div className="d-flex justify-content-between align-items-baseline mb-1">
                <h6 className="mb-0">{label}</h6>
                <span className="text-secondary" style={{ fontSize: "12px" }}>
                  {(options[key] || []).length} options
                </span>
              </div>
              <p className="text-secondary mb-3" style={{ fontSize: "12px" }}>
                {hint}
              </p>

              <div className="d-flex gap-2 mb-3">
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder={`Add a ${label.toLowerCase()}`}
                  value={drafts[key]}
                  maxLength={90}
                  onChange={(e) =>
                    setDrafts((d) => ({ ...d, [key]: e.target.value }))
                  }
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      add(key);
                    }
                  }}
                />
                <button
                  type="button"
                  className="btn btn-sm btn-dark px-3"
                  disabled={busy === key || !(drafts[key] || "").trim()}
                  onClick={() => add(key)}
                >
                  Add
                </button>
              </div>

              <ul className="list-unstyled mb-0">
                {(options[key] || []).map((option) => (
                  <li
                    key={option.id}
                    className="d-flex justify-content-between align-items-center py-1 border-top"
                  >
                    <span>{option.value}</span>
                    <button
                      type="button"
                      className="btn btn-sm btn-link text-danger p-0"
                      style={{ fontSize: "13px" }}
                      disabled={busy === key}
                      onClick={() => remove(key, option)}
                      title="Remove this option"
                    >
                      Remove
                    </button>
                  </li>
                ))}
                {(options[key] || []).length === 0 && (
                  <li className="text-secondary py-2" style={{ fontSize: "13px" }}>
                    Nothing here yet.
                  </li>
                )}
              </ul>
            </div>
          </div>
        ))}
      </div>

        <p className="text-secondary mt-4" style={{ fontSize: "13px" }}>
          An option still attached to a listing cannot be removed &mdash; change
          those listings first, so nothing is left pointing at a value that no
          longer exists.
        </p>
      </div>
      <Scrolltotopbtn />
      <Footer />
    </div>
  );
};

export default ManageAttributes;
